import { aboutData, projectInfo } from "../../../../data/site-data"

export const Footer = () => {
    return (
        <article className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="social-icons">
                            {aboutData.contactInfo.map((el, idx) => {
                                return (
                                    <div className="item" key={idx}>
                                        <a href={el.link} title={el.info} target="_blank" rel="noreferrer">
                                            <i className={el.iconClassname}></i>
                                        </a>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="footer-menu">
                            <small>
                                <small>{projectInfo.disclaimer}</small>
                                <br />
                                <small className="primary-color">{projectInfo.developer}</small>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    )
}
